import { observer } from 'mobx-react';

import crownslotsIcon from '../../assets/jackpot/crownslots.png';
import playsonIcon from '../../assets/jackpot/playson.png';
import pragmaticIcon from '../../assets/jackpot/pragmatic.png';
import { GameProvider } from '../../stores/game/types';
import { useStores } from '../../stores/useStores';
import { SocialCoin } from '../SocialCoin/SocialCoin';
import { SweepCoin } from '../SweepCoin/SweepCoin';

import { formatJackpotNumber } from './helpers';

import './JackpotBalance.scss';

type JackpotBalanceProps = {
  providerId: number;
  providerName?: string;
  badgeUrl?: string | null;
};

const GAME_PROVIDE_ICON_MAP: Record<GameProvider, string> = {
  [GameProvider.Pragmatic]: pragmaticIcon,
  [GameProvider.Playson]: playsonIcon,
  [GameProvider.PlaysonInfin]: playsonIcon,
  [GameProvider.Crownslots]: crownslotsIcon,
};

export const JackpotBalance = observer(({ providerId, providerName, badgeUrl }: JackpotBalanceProps) => {
  const { rewardsStore, coinTypeStore } = useStores();

  const { jackpot, fastJackpot } = rewardsStore;
  const jackpotAmount = jackpot.get(providerId);
  const fastJackpotAmount = fastJackpot.get(providerId) || 0;

  if (!jackpotAmount && jackpotAmount !== 0) {
    return null;
  }

  // Fallback logic
  badgeUrl = badgeUrl ?? GAME_PROVIDE_ICON_MAP[providerName as GameProvider];

  const isGC = coinTypeStore.coinType === 'GC';
  const Coin = isGC ? SocialCoin : SweepCoin;

  // GC: the full figure, whole, never abbreviated. SC: with its cents. The Crown (Splash) jackpot
  // badge stays whole on both coins.
  const jackpotAmountFormatted = formatJackpotNumber(Number(jackpotAmount) + Number(fastJackpotAmount), isGC ? 0 : 2);

  return (
    /*
     * No `--small` variant any more: it shrank the type at 8+ digits to buy room the pill did not
     * have. The pill now hugs its content and grows rightwards into empty tile.
     */
    <div className="jackpot-balance">
      {badgeUrl && <img alt={providerName} className="jackpot-balance-provider-icon" src={badgeUrl} />}
      <Coin className="jackpot-balance-coin-picture" />
      <div>{jackpotAmountFormatted}</div>
    </div>
  );
});
